import { css } from "@emotion/react";

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const strikethrough = css`
  background: linear-gradient(currentColor 1px, #0000 0) 0 0.5lh / 100% 1lh;
`;
